import { createContext, useContext } from 'react';

import { ProcessTalentResponseDTO, TalentDTO } from '@/api/generated';

type ProcessCardContextValue = {
  process: ProcessTalentResponseDTO;
  talent: TalentDTO;
};

export const TalentProcessContext = createContext<ProcessCardContextValue | undefined>(undefined);

export const useTalentProcessContext = () => {
  const context = useContext(TalentProcessContext);

  if (!context) throw new Error('No value in ProcessCardContext.Provider');

  return context;
};
